import React from "react";
const Copyright = () => {
    return (
        <>
        <hr></hr>
  
      <footer className="w-full bg-gray-900 text-white text-center py-4 mt-auto  bottom-0 left-0">
        <p className="text-sm">
        <span className="text-primary">  Watford Taxi </span> {new Date().getFullYear()}  © All Rights Reserved <span className="text-primary">Terms and Conditions</span>
        </p>
      </footer>
      </>
    );
  };
  
  export default Copyright;
  